// extracted by mini-css-extract-plugin
export default {"section":"Section_section__iIRx-","content":"Section_content__NztZH","decoration":"Section_decoration__lJMja","alwaysShow":"Section_alwaysShow__Fc+yf"};